module.exports = __webpack_public_path__ + "static/media/chart3.b8102b6e.png";